import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { MachinesRequisitionEntity } from "./entity/machines-requisition-entity";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { MachinesRequisituionController } from "./machines-requisition-controller";
import { MachinesRequisitionService } from "./mechines-requisition.service";
import { MachinesRequisitionSnapEntity } from "./entity/machine-requisition-snap-entity";
import { MachinesRequisitionSnapRepo } from "./repo/maachine-requisition-snap-repo";
import { MachinesRequisitionRepo } from "./repo/machines-requisition-repo";


@Module({
    imports: [
    TypeOrmModule.forFeature([MachinesRequisitionEntity,MachinesRequisitionSnapEntity]),
    ],
    controllers: [MachinesRequisituionController],
    providers: [ApplicationExceptionHandler,MachinesRequisitionService,MachinesRequisitionSnapRepo,MachinesRequisitionRepo ],
    exports: [TypeOrmModule],
})
export class MachinesRequisitionModule { }